import { render, staticRenderFns } from "./VerifyCalendarKyc.vue?vue&type=template&id=58886773&scoped=true"
import script from "./VerifyCalendarKyc.vue?vue&type=script&lang=js"
export * from "./VerifyCalendarKyc.vue?vue&type=script&lang=js"
import style0 from "./VerifyCalendarKyc.vue?vue&type=style&index=0&id=58886773&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58886773",
  null
  
)

export default component.exports